/* wrd-shopify-components: cb-header-fixes v1.0 (2026-09-25)
   Hotfix HF-001 (docs/bug-log.md). Monochrome's search panel (search-modal.js) and its drawers
   (BurgerDrawer in global.js, cart-drawer.js) do not coordinate: opening the menu or cart drawer
   while the search panel is open leaves the panel open underneath, and it is still covering the
   page after the drawer closes.

   This closes the search panel before either drawer opens. It listens in the capture phase so it
   runs before the drawer's own click handler, which means the drawer's scroll lock is applied
   after the search panel releases its own. It reuses the theme's close path (the overlay click
   handler in search-modal.js) when available, then enforces the closed state.
   Additive file; vendor scripts untouched. */
(function () {
  var DRAWER_TRIGGERS = '#burger-icon-bubble, #cart-icon-bubble';
  var PANELS = ['search-modal', 'search-modal-mobile'];

  function openPanels() {
    return PANELS.map(function (id) {
      return document.getElementById(id);
    }).filter(function (el) {
      return el && el.classList.contains('active');
    });
  }

  function closeSearch() {
    var open = openPanels();
    if (!open.length) return;

    // Theme close path first: search-modal.js binds its close to the overlay click (jQuery).
    var overlay = open[0].querySelector('.search-modal__overlay');
    if (overlay && window.jQuery) {
      window.jQuery(overlay).trigger('click');
    }

    // Enforce the closed state even if the theme path is unavailable.
    open.forEach(function (el) {
      el.classList.remove('active', 'predictive-open');
    });
    document.querySelectorAll('.search-modal__form-main[open]').forEach(function (el) {
      el.removeAttribute('open');
    });
    document.body.classList.remove('overflow-hidden');
  }

  function fromTrigger(target) {
    return target && target.closest && target.closest(DRAWER_TRIGGERS);
  }

  document.addEventListener('click', function (e) {
    if (fromTrigger(e.target)) closeSearch();
  }, true);

  document.addEventListener('keydown', function (e) {
    if ((e.code === 'Space' || e.key === 'Enter') && fromTrigger(e.target)) closeSearch();
  }, true);

  // Test hook for the smoke suite (no effect on shoppers).
  window.wrdHeaderFixes = { version: '1.0', closeSearch: closeSearch, openPanels: openPanels };
})();
